<template>
  <div>
    <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Guest</label>

    <!-- Added guests -->
    <div v-if="guests.length" class="mb-2 space-y-1">
      <div
        v-for="(guest, i) in guests"
        :key="i"
        class="flex items-center justify-between px-3 py-1.5 bg-gray-50 dark:bg-gray-800 rounded-lg"
      >
        <div>
          <p class="text-sm text-gray-700 dark:text-gray-200 leading-tight">{{ guest.full_name || guest.email }}</p>
          <p v-if="guest.full_name" class="text-[10px] text-gray-400 dark:text-gray-500">{{ guest.email }}</p>
        </div>
        <button
          @click="removeGuest(i)"
          class="w-5 h-5 flex items-center justify-center text-gray-400 hover:text-red-500 transition-colors"
          aria-label="Remove guest"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Add guest form -->
    <div v-if="adding" class="space-y-1.5 p-3 border border-blue-200 dark:border-blue-800 rounded-lg bg-blue-50/30 dark:bg-blue-900/10">
      <input
        v-model="draft.email"
        type="email"
        placeholder="Email address"
        class="w-full h-8 px-2.5 text-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-[#1C2128] border border-gray-200 dark:border-gray-700 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
        @keydown.enter.prevent="confirmAdd"
      />
      <input
        v-model="draft.full_name"
        type="text"
        placeholder="Name (optional)"
        class="w-full h-8 px-2.5 text-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-[#1C2128] border border-gray-200 dark:border-gray-700 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
        @keydown.enter.prevent="confirmAdd"
      />
      <div class="flex gap-2">
        <button @click="confirmAdd" :disabled="!draft.email" class="px-3 py-1 text-xs font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-40 transition-colors">Add</button>
        <button @click="adding = false; draft = { email: '', full_name: '' }" class="px-3 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors">Cancel</button>
      </div>
    </div>

    <button
      v-else
      @click="adding = true"
      class="flex items-center gap-1.5 text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors mt-1"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Add guest
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  guests: { type: Array, required: true },
})
const emit = defineEmits(['update:guests'])

const adding = ref(false)
const draft  = ref({ email: '', full_name: '' })

function confirmAdd() {
  if (!draft.value.email) return
  emit('update:guests', [...props.guests, { ...draft.value }])
  draft.value = { email: '', full_name: '' }
  adding.value = false
}

function removeGuest(index) {
  const updated = props.guests.filter((_, i) => i !== index)
  emit('update:guests', updated)
}
</script>
